
export const DRAFT_KEY = "arawaks.onboarding.v4";
export const STEPS = ["Inicio", "Campus", "Colegio", "Madre", "Padre", "Hijos", "Registro", "Listo"];
export const GRADES = [
  { value: 2015, label: "4to" },
  { value: 2014, label: "5to" },
  { value: 2013, label: "6to" },
  { value: 2012, label: "7mo" },
  { value: 2011, label: "8vo" },
  { value: 2010, label: "9no" },
];
export const SCHOOL_OPTIONS = ["Liceo Blueridge", "North Hill", "Ciudad de los Ni\u00f1os"];
export const DEFAULT_CHILD = { nombre: "", apellidoPaterno: "", apellidoMaterno: "", fechaNacimiento: "", generacion: 2015 };
export const EMPTY_PARENT = { nombre: "", apellidoPaterno: "", apellidoMaterno: "", telefono: "", correo: "" };
export const SIZE_NAMES = {
  nino_s: "Ni\u00f1o S", nino_m: "Ni\u00f1o M", nino_l: "Ni\u00f1o L", nino_xl: "Ni\u00f1o XL",
  adulto_s: "Adulto S", adulto_m: "Adulto M", adulto_l: "Adulto L", adulto_xl: "Adulto XL", adulto_xxl: "Adulto XXL",
};

export const inputProps = {
  h: "54px", rounded: "14px", bg: "public.bg.muted", color: "public.fg.default", borderColor: "transparent",
  _placeholder: { color: "public.fg.subtle" },
  _focus: { bg: "public.bg.panel", borderColor: "brand.red", boxShadow: "0 0 0 1px var(--chakra-colors-red-600)" },
};

export const selectStyle = {
  width: "100%", height: 54, padding: "0 14px", border: "1px solid transparent",
  borderRadius: 14, background: "var(--chakra-colors-public-bg-muted)", color: "var(--chakra-colors-public-fg-default)",
};

export function readDraft() {
  try { return JSON.parse(localStorage.getItem(DRAFT_KEY) || "{}"); }
  catch { return {}; }
}

export function phoneDigits(value) {
  return String(value || "").replace(/\D/g, "").slice(0, 10);
}

export function formatMexicanPhone(value) {
  const digits = phoneDigits(value);
  if (digits.length <= 2) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 2)} ${digits.slice(2)}`;
  return `${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6)}`;
}

export function validEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
}

export function parentComplete(parent) {
  return parent.nombre.trim().length >= 2 && parent.apellidoPaterno.trim() && parent.apellidoMaterno.trim() && phoneDigits(parent.telefono).length === 10 && validEmail(parent.correo);
}

